const SUB_DOMAIN = 'alfred';

const XERO_CLIENT_ID = '42AC461092CC485599829606F1AC7769';
const XERO_SCOPES = 'offline_access openid profile email accounting.transactions accounting.settings.read accounting.contacts accounting.attachments.read assets projects files';
const XERO_UNIQUE_STATE = 'dvsdhs?!*nwe';

const XERO_REDIRECT_URI = 'https://alfred.accelefreight.com/xero_callback'; // production redirect uri
// const XERO_REDIRECT_URI = 'http://localhost:8080/xero_callback'; // development redirect uri

export default {
  // API_HOST: "http://localhost:8081", // localhost for local testing
  // HOSTNAME: "http://localhost:8080", // localhost frontend name
  // AUTH_HOST: 'http://localhost:8081', // localhost for local testing

  GMAP_API_KEY: "AIzaSyArEFigs-M-jWy-GKohhwZ9AtFPoa2kpSI",

  API_HOST: "https://api.accelefreight.com", // Production Master Server
  HOSTNAME: `https://${SUB_DOMAIN}.accelefreight.com`, // production frontend name
  AUTH_HOST: "https://auth.accelefreight.com", // authentication server

  XERO_API_HOST: "https://api.xero.com/api.xro/2.0", // Xero api host

  XERO_TENANT_ID: "20ec5607-e720-4203-af1d-77e030827d71",  // Xero Tenant ID

  XERO_REDIRECT_URI: XERO_REDIRECT_URI,

  XERO_AUTH_URL: `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${XERO_CLIENT_ID}&redirect_uri=${XERO_REDIRECT_URI}&scope=${XERO_SCOPES}&state=${XERO_UNIQUE_STATE}`,

  TITLE: "AcceleFreight",
  COOKIES_LOGIN_KEY: "____afulr",

  COOKIE_XERO_ACCESS_TOKEN_KEY: "____afxeroaccesstoken",
  COOKIE_XERO_REFRESH_TOKEN_KEY: "____afxerorefreshtoken",

  ACTION_CODE_SETTING: {
    url: `https://${SUB_DOMAIN}.accelefreight.com/login`,
  },

  MINIMUM_HORIZON_WEEKS: 4,
  CONTAINER_DEFAULT_SIZE: 20,

  CONTACT_MAIL: "calvin.wong@accelefreight.com",
  INFO_MAIL: "info@accelefreight.com",

  IGNORE_PATHS: ["print-quotation-overview", "tracking"],

  //Account types
  AF_USER: "AFU",
  AF_CUSTOMER: "AFC",
  ACCOUNT_ADMIN: "AFU-ADMIN",
  ACCOUNT_CUSTOMER: "AFC-ADMIN",

  // super admin
  SUPER_ADMIN: ["calvin.wong@accelefreight.com", "isaac@accelefreight.com"],

  //Customer types
  CUSTOMER_CORPORATE: "corporate",
  CUSTOMER_PERSONAL: "personal",

  //Company type
  COMPANY_CUSTOMER: "CUSTOMER",

  // Shipment types
  QUOTATION_TYPE_SEA: "SEA",
  QUOTATION_TYPE_SEA_FCL: "FCL",
  QUOTATION_TYPE_SEA_LCL: "LCL",
  QUOTATION_TYPE_AIR: "AIR",
  QUOTATION_TYPE_WAREHOUSE: "WAREHOUSE",

  // container load
  CONTAINER_LOAD_FCL: "FCL",
  CONTAINER_LOAD_LCL: "LCL",

  // Transaction type
  TRANSACTION_TYPE_EXPORT: "EXPORT",
  TRANSACTION_TYPE_IMPORT: "IMPORT",

  // UOMs
  WILD_CARD : '*',
  UNIT_SET : 'SET',
  UNIT_CONTAINER : 'CTR',
  REVENUE_TONNE : 'RT',
  QUINTAL : 'QTL',  // 100 kg
  CBM_3KG : 'C3KG',  // 1:300 (1cbm : 300kg)
  CW_KG : 'CW', // Chargeable weight
  KG: 'KG',  // 1 kg
  
  // Air cubic conversion factor = 167
 AIR_CUBIC_CONVERSION_FACTOR: 167,

  // General Inquiry Company
  GENERAL_INQUIRY_COMPANY_ID: "AFC-0232",

  // Financial Component Types
  TYPE_OCEAN_FREIGHT_CHARGES: "ocean-freight-charges",
  TYPE_AIR_FREIGHT_CHARGES: "air-freight-charges",
  TYPE_EXPORT_CUSTOMS_CHARGES: "export-customs-charges",
  TYPE_IMPORT_CUSTOMS_CHARGES: "import-customs-charges",
  TYPE_EXPORT_LOCAL_CHARGES: "export-local-charges",
  TYPE_IMPORT_LOCAL_CHARGES: "import-local-charges",
  TYPE_EXPORT_DGCLASS_CHARGES: "export-dgclass-charges",
  TYPE_IMPORT_DGCLASS_CHARGES: "import-dgclass-charges",
  TYPE_EXPORT_HAULAGE_CHARGES: "export-haulage-charges",
  TYPE_IMPORT_HAULAGE_CHARGES: "import-haulage-charges",
  TYPE_EXPORT_TRANSPORT_CHARGES: "export-transport-charges",
  TYPE_IMPORT_TRANSPORT_CHARGES: "import-transport-charges",
  TYPE_STORAGE_CHARGES: "storage-charges",
  TYPE_REMOVAL_CHARGES: "removal-charges",
  TYPE_INSURANCE_CHARGES: "insurance-charges",
  TYPE_OTHER_SERVICES_CHARGES: "other-services-charges",
  TYPE_HANDLING_CHARGES: "handling-charges",
  TYPE_DISCOUNT_REBATE: "discount-rebate",
  TYPE_GENERAL_ITEM: "general-item",
  TYPE_TAXES_DUTIES_CHARGES: "taxes-duties-charges",

  // Shipment supplier status
  STATUS_SUPPLIER_NOT_ASSIGNED: 0,
  STATUS_SUPPLIER_SELECTED: 1,
  STATUS_SUPPLIER_NOTIFIED: 2,
  STATUS_SUPPLIER_CONFIRMED: 3,
  STATUS_SUPPLIER_REJECTED: 4,

  // Dialog identifiers
  DIALOG_NOTIFICATION: "dialog-notification",
  DIALOG_OCEAN_FREIGHT: "dialog-ocean-freight",
  DIALOG_HAULIER: "dialog-haulier",
  DIALOG_FINANCIALS: "dialog-financials",
  DIALOG_FINANCIALS_HAULAGE: "dialog-financials-haulage",

  DIALOG_COMPANY_RATES: "dialog-company-rates",
  DIALOG_CUSTOMER_RANK: "dialog-customer-rank",

  DIALOG_MANAGE_QUOTATION: "dialog-manage-quotation",
  DIALOG_QUOTATION_OVERVIEW: "dialog-quotation-overview",
  DIALOG_QUOTATION_FILES: "dialog-quotation-files",
  DIALOG_MANAGE_INVOICE: "dialog-manage-invoice",
  DIALOG_SCHEDULE_LIST: "dialog-schedule-list",

  DIALOG_SHIPMENT_CONTACTS: "dialog-shipment-contacts",
  DIALOG_SHIPMENT_TRANSPORTATION: "dialog-shipment-transportation",
  DIALOG_SHIPMENT_CONTAINER: "dialog-shipment-container",
  DIALOG_FILE_CABINET: "dialog-file-cabinet",
  DIALOG_SHIPMENT_INFORMARTION: "dialog-shipment-information",
  DIALOG_NOTIFY_PULL_BACK_READY: "dialog-notify-pull-back-ready",

  DIALOG_CONTACT_LAYOUT: "dialog-contact-layout",
  DIALOG_USER_ACCOUNT: "dialog-user-account",

  DIALOG_EMAIL_WIDGET: "dialog-email-widget",

  DIALOG_MESSAGE_BOX: "dialog-message-box",

  DEPARTURE_DATE_THRESHOLD: 14,

  NEW_SHIPMENT_OPTIONS: [{
      title: "Sea freight (FCL)",
      show: true,
      enabled: true
    },
    {
      title: "Sea freight (LCL)",
      show: true,
      enabled: false
    },
    {
      title: "Air freight",
      show: true,
      enabled: false
    }
    //{ title: 'Transport', show:false, enabled: false }
  ],

  CONTAINER_SIZES: [{
      label: "Less than container load (LCL)",
      value: -1
    },
    {
      label: "20 footer",
      value: 20
    },
    {
      label: "40 footer",
      value: 40
    }
  ],

  SUPPORTED_CURRENCIES: ["MYR", "USD"],

  STATE_OTHER: {
    code: "OTHER",
    name: "Other"
  },
  CITY_OTHER: {
    code: "OTHER",
    name: "Other"
  },

  NEW_SHIPMENT: {
    STEP_1_LABEL: "1. Date and location",
    STEP_2_LABEL: "2. Shipment details",
    STEP_3_LABEL: "3. Price options",
    STEP_4_LABEL: "4. Documentation",
    STEP_5_LABEL: "5. Review and confirm"
  },

  // Response status
  RESPONSE_STATUS_OK: "OK",
  RESPONSE_STATUS_EXISTS: "EXISTS",
  RESPONSE_STATUS_EMPTY: "EMPTY",
  RESPONSE_STATUS_LOGOUT: "LOGOUT",

  WORKFLOW_FORMAT: {
    shipment_to_port: {
      color: "green lighten-2",
      color_code: "#81C784",
      text_color: "green",
      icon: "mdi-truck-delivery",
    },
    export_clearance: {
      color: "indigo lighten-2",
      color_code: "#7986CB",
      text_color: "indigo",
      icon: "mdi-shield-search",
    },
    vessel_departure: {
      color: "deep-orange lighten-2",
      color_code: "#FF8A65",
      text_color: "deep-orange",
      icon: "mdi-anchor",
    },
    vessel_in_transit: {
      color: "red lighten-2",
      color_code: "#E57373",
      text_color: "red",
      icon: "mdi-ferry",
    },
    vessel_arrival: {
      color: "teal lighten-2",
      color_code: "#4DB6AC",
      text_color: "teal",
      icon: "mdi-anchor",
    },
    import_clearance: {
      color: "indigo lighten-2",
      color_code: "#7986CB",
      text_color: "indigo",
      icon: "mdi-shield-search",
    },
    shipment_delivery: {
      color: "cyan lighten-2",
      color_code: "#4DD0E1",
      text_color: "cyan",
      icon: "mdi-truck-check",
    },
    shipment_closed: {
      color: "green lighten-2",
      color_code: "#81C784",
      text_color: "green darken-3",
      icon: "mdi-check",
    },
    empty: {
      color: "green lighten-2",
      color_code: "#81C784",
      text_color: "green darken-3",
      icon: "mdi-alert-circle",
    }
  },

  // Invoice View
  SHIPMENT_INVOICE: "SHIPMENT",
  TAXES_DUTIES_INVOICE: "TAXES-DUTIES",
  OTHER_SERVICES_INVOICE: "OTHER-SERVICES",

  // Booking files
  BOOKING_FILES: ["CPL", "CINV"],

  // Workflow constants. This must align with webserver values
  STATUS: {
    QUOTATION: {
      EXPIRED: -1,
      DRAFT: 1001,
      REQUEST: 1002,
      PROPOSED: 2001,
      PRICE_UPDATED: 2002,
      CONFIRMED: 3001,
      SHIPMENT_COMPLETED: 4001,
      INVOICE_ISSUED: 4002,
      INVOICE_PAID: 5001,
      CLOSED: 10001
    },

    SHIPMENT_ORDER: {
      DELETED: -1,
      CREATED: 1,

      // SELECT_SHIPMENT_SCHEDLE: 10,
      // SHIPMENT_SCHEDULE_SELECTED: 20,
      // SHIPMENT_SCHEDULE_REASSIGNED: 21,

      BOOKING_STARTED: 100,
      BOOKING_CONFIRMED: 110,

      SHIPMENT_READY_FOR_PICKUP: 200,
      SHIPMENT_PICKUP_IN_PROGRESS: 201,
      SHIPMENT_PICKUP_COMPLETED: 210,

      SHIPMENT_ARRIVED_AT_ORIGIN_PORT: 1000,
      SHIPMENT_EXPORT_CLEARANCE: 1001,
      SHIPMENT_LOADED_ONTO_VESSEL: 1002,
      VESSEL_DEPARTURE: 1003,

      VESSEL_IN_TRANSIT: 2000,

      SHIPMENT_ARRIVED_AT_DESTINATION_PORT: 3000,
      SHIPMENT_UNLOADED_FROM_VESSEL: 3100,
      SHIPMENT_IMPORT_CLEARANCE: 3200,

      SHIPMENT_READY_FOR_DELIVERY: 4100,
      SHIPMENT_DELIVERY_IN_PROGRESS: 4101,
      SHIPMENT_DELIVERY_COMPLETED: 4110,

      SHIPMENT_COMPLETE: 10000
    },

    TASK: {
      UNASSIGNED: 100,
      ASSIGNED: 200,
      COMPLETED: 300
    },

    INVOICE: {
      DRAFT: 1001,
      SUBMITTED: 2001,
      DELETED: 100,
      AUTHORISED: 3001,
      VOIDED: 200,
      PAID: 4001
    }
  },

  isObjectEmpty: function (object) {
    return Object.keys(object).length <= 0
  },

  containsObject: function (obj, list) {
    var i
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true
      }
    }

    return false
  },

  getDate: function (offset) {
    var today = new Date()
    today.setDate(today.getDate() + offset)
    var dd = today.getDate()
    var mm = today.getMonth() + 1 //January is 0!

    var yyyy = today.getFullYear()
    if (dd < 10) {
      dd = "0" + dd
    }
    if (mm < 10) {
      mm = "0" + mm
    }
    var today = yyyy + "-" + mm + "-" + dd

    return today
  },

  getDateFromDateTimeString: function (dateTimeStr) {
    if (dateTimeStr != null) {
      return dateTimeStr.substring(0, 10)
    } else {
      return "N/A"
    }
  },

  addDaysToDate: function (dateStr, days) {
    var date = new Date(dateStr)

    date.setDate(date.getDate() + days)

    var dd = date.getDate()
    var mm = date.getMonth() + 1 //January is 0!

    var yyyy = date.getFullYear()
    if (dd < 10) {
      dd = "0" + dd
    }
    if (mm < 10) {
      mm = "0" + mm
    }

    var returnStr = yyyy + "-" + mm + "-" + dd

    return returnStr
  },

  parseTime: function (timeStr) {
    if (timeStr == null) {
      return null
    }

    var time = timeStr.match(
      /^\s*(\d\d?)(?::?(\d\d))?(?::(\d\d))?(?!\d)(\.\d+)?\s*(pm?|am?)?/i
    )
    if (time) {
      var localDate = false
      var hour = parseInt(time[1]),
        pm = (time[5] || " ")[0].toUpperCase()
      var min = time[2] ? parseInt(time[2]) : 0
      //var sec = time[3] ? parseInt(time[3]) : 0;
      //var ms = (time[4] ? parseFloat(time[4]) * 1000 : 0);
      if ((pm !== " " && (hour == 0 || hour > 12)) || hour > 24 || min >= 60)
        return null
      if (pm === "A" && hour === 12) hour = 0
      if (pm === "P" && hour !== 12) hour += 12
      if (hour === 24) hour = 0
      var date = new Date(localDate !== undefined ? localDate.valueOf() : 0)
      var set = localDate !== undefined ? date.setHours : date.setUTCHours
      set.call(date, hour, min)
      return date
    }
    return null
  },

  getUnique: function (arr, comp) {
    const unique = arr
      .map(e => e[comp])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter(e => arr[e])
      .map(e => arr[e])

    return unique
  },

  elipseString: function (string, length) {
    var elipsedString = string

    if (elipsedString != null && elipsedString.length > length) {
      elipsedString = elipsedString.substring(0, length) + "..."
    }

    return elipsedString
  },

  getFlag(countryCode) {
    try {
      return require(`@/assets/flags/4x3/${countryCode.toLowerCase()}.svg`)
    } catch (e) {
      return require("@/assets/flags/4x3/undefined.svg")
    }
  },

  sleep(milliseconds) {
    var start = new Date().getTime()
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break
      }
    }
  }
}